import {
  Field as HeadlessField,
  type FieldProps as HeadlessFieldProps,
} from "@headlessui/react";
import classNames from "classnames";
import { type ElementType } from "react";

import { FieldContext } from "./FieldContext";

export type FieldProps<T extends ElementType = "div"> = HeadlessFieldProps<T>;

export default function Field<TTag extends ElementType = "div">({
  inline = false,
  grid = false,
  ...props
}: FieldProps<TTag> &
  ({ inline?: boolean; grid?: never } | { inline?: never; grid?: boolean })) {
  return (
    <FieldContext.Provider value={{ inline, grid }}>
      <HeadlessField
        className={classNames(
          grid
            ? "sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
            : inline
              ? "flex items-start gap-2"
              : "flex flex-col gap-1.5",
        )}
        {...props}
      />
    </FieldContext.Provider>
  );
}
